import React from 'react';
import { useParams } from 'react-router-dom';
import DetailNote from './DetailNote';

// Page /note/:id — enveloppe de route autour du détail partagé (utilisée par
// la compta, le bandeau de succès et les liens directs).
function NoteDetail() {
  const { id } = useParams();
  return <DetailNote id={id} />;
}

export default NoteDetail;
